// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__4kvg2","content":"LoadingAlert_content__3k-Tp"};